import { CITED_PRINTS } from "../content";

/** Google Dataset Search wants Organization|Person on creator, and a license URL or CreativeWork. */
export function citedPrintsDataset(input: {
  url: string;
  origin: string;
  broker: string;
  modified: string;
}) {
  const { url, origin, broker, modified } = input;
  return {
    "@type": "Dataset",
    "@id": `${url}#cited-prints`,
    name: "Cited new-customer home loan prints — Azure Home Loans panel",
    description:
      "Advertised owner-occupier P&I prints this brokerage can place, with LVR caps. Not a ranking. Confirm on the lender page.",
    dateModified: modified,
    temporalCoverage: modified,
    creator: {
      "@type": "Organization",
      "@id": `${origin}/#broker`,
      name: broker,
      url: origin,
    },
    license: {
      "@type": "CreativeWork",
      name: "General information only. Confirm each print on the lender page. Not a ranking and not licensed for republication as a comparison catalogue.",
      url,
    },
    isAccessibleForFree: true,
    variableMeasured: "Interest rate",
    citation: CITED_PRINTS.map((row) => `${row.lender} ${row.product} ${row.rate.toFixed(2)}% · ${row.lvr}`),
  };
}
